module.exports = __webpack_public_path__ + "img/hh-logo.3c775276.svg";